
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'player'
})
export default class Player extends Vue {
  headless = false;
  created() {
    this.headless = this.$route.meta.headless;
  }
}
